import { ReactNode, Children } from 'react';
import { Stack } from '@mui/material';
import { useSlotContext } from '@upheal/design-system/utils/useSlotContext';

import { modalHeaderClassName, paddingValues } from './Modal.styleUtils';

interface ModalFooterProps {
    children: ReactNode;
}

export const ModalFooter = ({ children }: ModalFooterProps) => {
    const { sizing = 'md' } = useSlotContext({}, 'modal');

    return (
        <Stack
            direction="row"
            sx={{
                ...paddingValues[sizing],
                alignItems: 'center',
                justifyContent:
                    Children.count(children) === 1
                        ? 'flex-end'
                        : 'space-between',
                borderTop: '1px solid',
                borderColor: 'ds.border.neutral.secondary',

                /**
                 * When footer is direct sibling of the header (because no modal content)
                 * prevent doubling separation line
                 */
                [`.${modalHeaderClassName} + &`]: {
                    borderTop: 'none',
                },
            }}
        >
            {children}
        </Stack>
    );
};
